// Company Branding Constants
export const BRAND_NAME = "INFINITY ENTERPRISES";
export const COMPANY_NAME_MAIN = "INFINITY";
export const COMPANY_NAME_SUBTITLE = "ENTERPRISES";
export const COMPANY_DISPLAY_NAME = "Infinity Enterprises"; // For user-friendly display
export const COMPANY_SHORT_NAME = "Infinity"; // For short references

// Company Information
export const COMPANY_TAGLINE = "Production Workflow Management";
export const COMPANY_DESCRIPTION = "Infinity Enterprises - Production Workflow Management System";
export const COMPANY_WEBSITE = "https://infinityenterprises.com";

// Developer Information
export const DEVELOPER_NAME = "MAWSOFTWARES";
export const DEVELOPER_WEBSITE = "https://mawsoftwares.com";

// Copyright
export const COPYRIGHT_TEXT = `${COMPANY_DISPLAY_NAME}. All rights reserved.`;

// App Configuration
export const APP_NAME = "Infinity Orders";
export const APP_VERSION = "1.0.0";
export const APP_DESCRIPTION = "Production Workflow Management System";

// PWA Configuration
export const PWA_NAME = "Infinity Worriers";
export const PWA_SHORT_NAME = "Worriers";

// Email Templates
export const EMAIL_FROM_NAME = COMPANY_DISPLAY_NAME;
export const WELCOME_EMAIL_SUBJECT = `Welcome to ${COMPANY_DISPLAY_NAME} - Your Account Details`;
export const PASSWORD_RESET_SUBJECT = `Password Reset Request - ${COMPANY_DISPLAY_NAME}`;
export const API_TITLE = `${COMPANY_DISPLAY_NAME} API`;
